import { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const TenantContext = createContext({ tenantId: null, loading: true });

export function useTenant() {
  return useContext(TenantContext);
}

export function TenantProvider({ children }) {
  const { currentUser, userData, loading: authLoading } = useAuth();
  const [tenantId, setTenantId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;

    if (!currentUser) {
      setTenantId(null);
      setLoading(false);
      return;
    }

    // THE APEX FIX: Safe fallback for global administrators bypassing standard tenant boundaries
    const activeTenant = userData?.tenant_id || 'SYS_ADMIN';

    if (activeTenant) {
      setTenantId(activeTenant);
    } else {
      console.error("CRITICAL: Corporate identity not resolved. User document is missing 'tenant_id' payload.");
      setTenantId(null);
    }

    setLoading(false);

  }, [currentUser, authLoading, userData]);

  return (
    <TenantContext.Provider value={{ tenantId, loading }}>
      {children}
    </TenantContext.Provider>
  );
}